import { type ChatbotConfiguration } from '@src/types/chatbot';
import { type LoaderFunction } from 'react-router-dom';
import { getLiveConfiguration } from '@src/api/services/chatbot/configurationService';

export type ChatbotViewLoaderData = {
  jobId: string;
  chatbotConfig: ChatbotConfiguration;
};

export const chatbotViewLoader = (async ({
  params,
}): Promise<ChatbotViewLoaderData | Response> => {
  const { jobId } = params;
  const chatbotConfig = await getLiveConfiguration(jobId!, 'Chatbot');
  return { jobId: jobId!, chatbotConfig };
}) satisfies LoaderFunction;
